module.exports = __webpack_public_path__ + "img/dollar.92fb44d3.svg";